import { render } from "./Order_DetailPage .vue?vue&type=template&id=36eafaff"
import script from "./Order_DetailPage .vue?vue&type=script&lang=js"
export * from "./Order_DetailPage .vue?vue&type=script&lang=js"

import "./Order_DetailPage .vue?vue&type=style&index=0&id=36eafaff&lang=css"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__